'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var LRUCache = require('lru-cache');

var createDebugLogger = require('debug');

var KBucket = require('./kbucket');

var debug = createDebugLogger('devp2p:dpt:ban-list');

var BanList =
/*#__PURE__*/
function () {
  function BanList() {
    _classCallCheck(this, BanList);

    this._lru = new LRUCache({
      max: 30000
    }); // 10k should be enough (each peer obj can has 3 keys)
  }

  _createClass(BanList, [{
    key: "add",
    value: function add(obj, maxAge) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = KBucket.getKeys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;
          debug("add ".concat(key, ", size: ").concat(this._lru.length));

          this._lru.set(key, true, maxAge);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "has",
    value: function has(obj) {
      var _this = this;

      return KBucket.getKeys(obj).some(function (key) {
        return _this._lru.get(key);
      });
    }
  }]);

  return BanList;
}();

module.exports = BanList;